// removed by extract-text-webpack-plugin
module.exports = {"root":"_52LPFaBJkPtH_mmSnPdgy","suggestion-list":"_1oswQBAaV4jU_KAy2_mt8U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/area-picker.scss
// module id = 1477
// module chunks = 0